module.exports = __webpack_public_path__ + "453ec7ae8129ddaebe324144b9559430.svg";